import { codigoDominioDe, traducirError } from '@tanteo/compartido';

/**
 * El error de la capa de datos como `Error` de verdad: el objeto de PostgREST es plano y las
 * pantallas muestran el motivo con `instanceof Error`. El `message` llega traducido; el texto crudo
 * del servidor queda en `mensajeCrudo` para el log, jamás para la pantalla.
 */
export class ErrorDeApi extends Error {
  /** Código de Postgres o PostgREST: `P0001`, `42501`, `PGRST301`… */
  readonly codigo?: string;
  /** Código de dominio del propio esquema, del prefijo `TN_*` del mensaje. */
  readonly codigoDominio?: string;
  /** Status HTTP. 0 = el fetch falló (sin red). */
  readonly status?: number;
  /** El texto crudo del servidor: para el log, jamás para la pantalla. */
  readonly mensajeCrudo?: string;

  constructor(bruto: { code?: string | null; message?: string | null } | null | undefined, status?: number) {
    const b = bruto ?? {};
    super(traducirError({ code: b.code, message: b.message, status }));
    this.name = 'ErrorDeApi';
    this.codigo = b.code ?? undefined;
    this.codigoDominio = codigoDominioDe(b.message ?? undefined);
    this.status = status;
    this.mensajeCrudo = b.message ?? undefined;
  }
}
